import React from "react";
import { FormControl, FormGroup, Checkbox, FormControlLabel, FormHelperText } from '@mui/material';


export const APICheckBoxField = (props) => {
    const {
        errors = [],
        label='',
        value,
        onChange,
        name,
        disabled = false,
        sx = {m: 1, minWidth: 120},
        variant = "standard",
    } = props;

    let errMsg = ""

    if (errors.length > 0) {
        errMsg = errors.map(({message}) => `${message}`).reduce((msg1, msg2) => `${msg1}\n${msg2}`)
    }

    return (
        <FormControl
        required
        error={!!errMsg}
        sx={sx}
        variant={variant}
        component="fieldset"
        >
        <FormGroup>
        <FormControlLabel
        label={label}
        control={
            <Checkbox
            name={name}
            checked={value}
            onChange={onChange}
            />
        }
        disabled={disabled}
        />
        </FormGroup>
        {!!errMsg && <FormHelperText>{errMsg}</FormHelperText>}
        </FormControl>
        )
    }
